export default "__VITE_ASSET__BbOy0n6___"